import React from 'react';
import { NotFound } from '@/modules/Errors';

const Custom404 = () => {
  return <NotFound />;
};

export default Custom404;
